import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/site';

export default function SiteIntro() {
  return (
    <section className="max-w-7xl mx-auto px-4 md:px-8 py-12">
      <div className="rounded-lg border border-background-200 bg-background-50 overflow-hidden grid grid-cols-1 lg:grid-cols-2">
        <div className="p-6 md:p-10 flex flex-col justify-center">
          <span className="text-sm font-bold text-accent-600 tracking-wide">关于 51每日大赛</span>
          <h2 className="mt-3 text-2xl md:text-3xl font-black text-foreground-950 tracking-tight">
            专业、及时的每日赛事信息平台
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            {siteInfo.intro}
          </p>
          <ul className="mt-6 space-y-3">
            {siteInfo.services.map((service) => (
              <li key={service.title} className="flex items-start gap-3">
                <span className="w-9 h-9 rounded-md bg-primary-50 text-primary-600 flex items-center justify-center shrink-0">
                  <i className={`${service.icon} text-lg`}></i>
                </span>
                <div>
                  <p className="text-sm font-bold text-foreground-900">{service.title}</p>
                  <p className="text-sm text-foreground-500 leading-relaxed">{service.description}</p>
                </div>
              </li>
            ))}
          </ul>
          <Link
            to="/about"
            className="mt-7 self-start px-5 py-2.5 rounded-md bg-primary-600 text-background-50 text-sm font-medium hover:bg-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            了解我们
          </Link>
        </div>
        <div className="relative h-64 lg:h-auto">
          <img
            src="https://readdy.ai/api/search-image?query=Esports%20analyst%20working%20at%20a%20desk%20with%20multiple%20monitors%20showing%20ranking%20charts%20and%20statistics%2C%20deep%20navy%20blue%20ambient%20light%20with%20warm%20orange%20accents%2C%20professional%20editorial%20photography%2C%20high%20detail&width=900&height=800&seq=home-intro-img&orientation=portrait"
            alt="51每日大赛 数据分析工作场景"
            title="51每日大赛 赛事数据分析"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-tr from-primary-950/35 to-transparent"></div>
        </div>
      </div>
    </section>
  );
}